// extracted by mini-css-extract-plugin
module.exports = {"strength":"_8ff43fb","initialized":"_3594b9c","weak":"_1db8df2","medium":"_0026cc6","strong":"_36324c5"};